module.exports = __webpack_public_path__ + "static/Yogesh-Desai-1d73d8c799ef68fceb2428ae156ba44e.png";